// Day-off job types on daily timesheets: sick (3) and vacation (4).
// These rows represent absence, not worked time, so hours and shift task fields aren't editable.
export const DAY_OFF_JOB_TYPES = {
  3: true,
  4: true
};
